"use strict";
/**
 * Copyright © 2020 Johnson & Johnson
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var core_1 = require("@bodiless/core");

var _1 = __importDefault(require("."));
/**
 * Returns a component selector wrapped in a context menu form.
 *
 * @param props Props passed to the edit flow container.
 * @param onSelect The action to perform when a component is selected.
 */


var componentSelectorForm = function componentSelectorForm( // @TODO: Separate component selector props from edit flow container props.
props, _onSelect) {
  return core_1.contextMenuForm({
    initialValues: {
      selection: ''
    },
    hasSubmit: false
  })(function (_a) {
    var ui = _a.ui,
        closeForm = _a.closeForm;
    return react_1.default.createElement(_1.default, __assign({}, props, {
      ui: __assign(__assign({}, ui), props.ui),
      closeForm: closeForm,
      onSelect: function onSelect() {
        var args = [];

        for (var _i = 0; _i < arguments.length; _i++) {
          args[_i] = arguments[_i];
        }

        _onSelect.apply(void 0, args);

        closeForm(null);
      },
      components: Object.values(props.components),
      mandatoryCategories: props.mandatoryCategories
    }));
  });
};

exports.default = componentSelectorForm;